export default __webpack_public_path__ + "static/asteroide-gray-36c9e0724573771a2c10f17c36e130bd.svg";